import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("PersonnelStatusPermissions")
export class PersonnelStatusPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
}